import { render, staticRenderFns } from "./org-invite.vue?vue&type=template&id=5c2fe050&scoped=true&"
import script from "./org-invite.vue?vue&type=script&lang=js&"
export * from "./org-invite.vue?vue&type=script&lang=js&"
import style0 from "./org-invite.vue?vue&type=style&index=0&id=5c2fe050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2fe050",
  null
  
)

export default component.exports